import { getUrl, getCookie, getLocalStroage, getClip } from "./utils"
const mapper: { [key: string]: any } = {
  url: getUrl,
  cookie: getCookie,
  localStorage: getLocalStroage,
  clip: getClip,
}
export const proxy = {
  params(key: string, name?: string): Promise<string | undefined> {
    return new Promise((resolve, reject) => {
      if (!key?.length) return ""
      try {
        resolve(mapper[key](name))
      } catch (e) {
        resolve(e)
      }
    })
  },
}
